import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { ChevronRightIcon } from '../../../../../core/themes/icons/ChevronRightIcon';
import { ChevronLeftIcon } from '../../../../../core/themes/icons/ChevronLeftIcon';
import Tooltip from '@material-ui/core/Tooltip';

const TreeListButtons = ({
  classes,
  handleAddClick,
  handleAddAllClick,
  handleRemoveClick,
  handleRemoveAllClick,
  stepReadOnly,
  selectionError
}) => {
  const defaultChevronStyle = {
    fontWeight: '900',
    color: '#2962FF'
  };

  // Conditionally update the color for ChevronRight buttons
  const chevronStyleForAdd = {
    ...defaultChevronStyle,
    color: selectionError ? '#00000040' : defaultChevronStyle.color
  };

  return (
    <Grid
      item
      xs={1}
      direction="column"
      alignItems="center"
      justifyContent="center"
      container
      className={classes.gridSmall}
      style={{ height: '100%' }}
    >
      <Tooltip
        placement="top"
        arrow
        title={
          selectionError
            ? 'Fund(s) and Fund-Investor Tag can not be added at the same time'
            : ''
        }
      >
        <span>
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={handleAddClick}
            disabled={stepReadOnly || selectionError}
            id="chevron-right"
          >
            <ChevronRightIcon style={chevronStyleForAdd} />
          </Button>
        </span>
      </Tooltip>
      <Tooltip
        placement="top"
        arrow
        title={
          selectionError
            ? 'Fund(s) and Fund-Investor Tag can not be added at the same time'
            : ''
        }
      >
        <span>
          <Button
            variant="outlined"
            color="primary"
            className={classes.separateButton}
            onClick={handleAddAllClick}
            disabled={stepReadOnly || selectionError}
            id="double-chevron-right"
          >
            <ChevronRightIcon style={chevronStyleForAdd} />
            <ChevronRightIcon style={chevronStyleForAdd} />
          </Button>
        </span>
      </Tooltip>
      <Button
        variant="outlined"
        color="primary"
        className={classes.button}
        onClick={handleRemoveClick}
        disabled={stepReadOnly}
        id="chevron-left"
      >
        <ChevronLeftIcon style={defaultChevronStyle} />
      </Button>
      <Button
        variant="outlined"
        color="primary"
        className={classes.button}
        onClick={handleRemoveAllClick}
        disabled={stepReadOnly}
        id="double-chevron-left"
      >
        <ChevronLeftIcon style={defaultChevronStyle} />
        <ChevronLeftIcon style={defaultChevronStyle} />
      </Button>
    </Grid>
  );
};

export default TreeListButtons;
